class Noticias {

    main = null;
    list = null;
    next = null;
    page = 1;
    parPage = 9;

    constructor(){

        this.main = document.querySelector( '#list-posts' );
        if( !this.main ) return null;

        this.init();

    }

    async init() {
        this.list = this.main.querySelector( '.list-items' );
        this.loadItems( true );
    }

    async loadItems( initial ){

        const result = await this.requestItems();
        if( result.success === true ){
            if( result.data ){
                this.receiveResults( result.data );
            }
            else if( initial === true ){
                this.main.remove();
            }
        }
        else {
            console.info('result');
            console.log(result);
        }

    }

    receiveResults( data ){

        // Insert items
        const wrap = document.createElement('div');
        wrap.innerHTML = data.content;
        const items = wrap.querySelectorAll( '.card-news' );
        for( const item of items ){
            this.list.appendChild( item );
        }

        // Load more
        if( this.next ){
            this.next.remove();
        }
        if( data.next ){

            const temp = document.createElement('div');
            temp.innerHTML = data.next;
            this.next = temp.firstElementChild;
            this.next.addEventListener( 'click', e => {
                e.preventDefault();
                this.page = this.next.dataset.page;
                this.loadItems();
            });
            this.main.appendChild( this.next );

        }

    }



    async requestItems(){

        const vpWidth = window.innerWidth;
        const perPage = vpWidth > 1281 ? 12 : ( vpWidth > 767 ? 9 : 8 );

        if( this.next ){
            this.next.classList.add( 'loading' );
        }

        try {

            const response = await fetch(
                `${Piki.ajaxurl}?action=flivre_homenews`, 
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({
                        page: this.page,
                        per_page: perPage
                    })
                }
            );

            const data = await response.json();
            return data;

        } 
        catch (error) {

            console.error('Erro:', error);
        
        }
        finally {

            if( this.next ){
                this.next.classList.remove( 'loading' );
            }
        
        }

    }

}
window.addEventListener( 'DOMContentLoaded', () => {
    new Noticias();
})